import React from 'react';

interface InputLabelProps {
  htmlFor?: string;
  required?: boolean;
  children: React.ReactNode;
}

export const InputLabel: React.FC<InputLabelProps> = ({ 
  htmlFor, 
  required, 
  children 
}) => {
  return (
    <label htmlFor={htmlFor} className="ui-input__label">
      {children}
      {required && <span className="ui-input__required">*</span>}
    </label>
  );
};
